var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("article", { staticClass: "box" }, [
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("div", { staticClass: "columns is-gapless" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Other Labour"),
                      ]),
                      _c("subtitle-totals", {
                        attrs: {
                          labels: ["Other Labour Total", "Grand Total"],
                          totals: [_vm.otherTotal, _vm.innerValue.totalExGst],
                          shows: [true, true],
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                      draggable: true,
                      "show-pagination": false,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _c(
                      "draggable",
                      _vm._b(
                        {
                          attrs: { tag: "tbody", handle: ".item-drag-handle" },
                          on: { change: _vm.itemMoved, end: _vm.endMove },
                          model: {
                            value: _vm.innerValue.others,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerValue, "others", $$v)
                            },
                            expression: "innerValue.others",
                          },
                        },
                        "draggable",
                        {
                          disabled: !_vm.isRowDraggable,
                          chosen: "chosen",
                          ghostClass: "draggable-ghost",
                          dragClass: "draggable-drag",
                        },
                        false
                      ),
                      _vm._l(_vm.activeItems, function (item, index) {
                        return _c(
                          "tr",
                          {
                            key: item.quoteItemId,
                            class: [
                              _vm.defaultRowColourClass(
                                item,
                                _vm.getItemAssessments(item),
                                false
                              ),
                              _vm.rowDisplayStatus(
                                item,
                                _vm.getItemAssessments(item)
                              ),
                            ],
                            attrs: { "data-itemid": item.quoteItemId },
                            on: {
                              click: function ($event) {
                                return _vm.highlightSelected(index, $event)
                              },
                            },
                          },
                          [
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$userInfo.isSupportUser,
                                    expression: "$userInfo.isSupportUser",
                                  },
                                ],
                                staticClass:
                                  "has-vertical-middle has-text-right linenumber-input",
                              },
                              [
                                !_vm.innerValue.readOnly &&
                                _vm.$userInfo.isSupportUser &&
                                !_vm.readOnlyView &&
                                !_vm.isItemRemoved(
                                  item,
                                  _vm.getItemAssessments(item)
                                )
                                  ? _c("vue-numeric", {
                                      staticClass: "input has-text-right",
                                      class: _vm.defaultRowColourClass(
                                        item,
                                        _vm.getItemAssessments(item),
                                        false
                                      ),
                                      attrs: { precision: 0, separator: "" },
                                      model: {
                                        value: item.lineNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "lineNumber",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.lineNumber",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(_vm._s(item.lineNumber)),
                                    ]),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "has-vertical-middle itemno-input",
                              },
                              [
                                !item.deleteOtherItem &&
                                !_vm.innerValue.readOnly &&
                                !_vm.readOnlyView &&
                                !_vm.audanetLock &&
                                !_vm.isItemRemoved(
                                  item,
                                  _vm.getItemAssessments(item)
                                )
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.itemNo,
                                          expression: "item.itemNo",
                                        },
                                      ],
                                      staticClass: "input",
                                      class: [
                                        _vm.defaultRowColourClass(
                                          item,
                                          _vm.getItemAssessments(item),
                                          false
                                        ),
                                        !_vm.isValidItemNo(item.quoteItemId)
                                          ? "is-danger"
                                          : "",
                                      ],
                                      attrs: { placeholder: "Item No." },
                                      domProps: { value: item.itemNo },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "itemNo",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("span", [_vm._v(_vm._s(item.itemNo))]),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle itemdesc-input",
                              },
                              [
                                !item.deleteOtherItem &&
                                !_vm.innerValue.readOnly &&
                                !_vm.readOnlyView &&
                                !_vm.audanetLock &&
                                !_vm.isItemRemoved(
                                  item,
                                  _vm.getItemAssessments(item)
                                )
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.itemDesc,
                                          expression: "item.itemDesc",
                                        },
                                      ],
                                      staticClass: "input",
                                      class: [
                                        _vm.defaultRowColourClass(
                                          item,
                                          _vm.getItemAssessments(item),
                                          false
                                        ),
                                        !_vm.isValidItemDesc(item.quoteItemId)
                                          ? "is-danger"
                                          : "",
                                      ],
                                      attrs: {
                                        placeholder: "Item Description",
                                      },
                                      domProps: { value: item.itemDesc },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "itemDesc",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("span", [_vm._v(_vm._s(item.itemDesc))]),
                                item.itemComment
                                  ? _c(
                                      "div",
                                      { staticClass: "help is-primary" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "has-text-weight-bold",
                                          },
                                          [_vm._v("Comment: ")]
                                        ),
                                        _c("span", [
                                          _vm._v(_vm._s(item.itemComment)),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-centered",
                              },
                              [
                                !item.deleteOtherItem &&
                                !_vm.innerValue.readOnly &&
                                !_vm.readOnlyView &&
                                !_vm.audanetLock &&
                                !_vm.isItemRemoved(
                                  item,
                                  _vm.getItemAssessments(item)
                                )
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.reportOnly,
                                              expression: "item.reportOnly",
                                            },
                                          ],
                                          attrs: {
                                            disabled:
                                              !_vm.canMakeReportOnly(item),
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              item.reportOnly
                                            )
                                              ? _vm._i(item.reportOnly, null) >
                                                -1
                                              : item.reportOnly,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = item.reportOnly,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      item,
                                                      "reportOnly",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      item,
                                                      "reportOnly",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  item,
                                                  "reportOnly",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "state p-primary" },
                                          [
                                            _c("i", {
                                              staticClass: "icon mdi mdi-check",
                                            }),
                                            _c("label"),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "icon has-text-info" },
                                      [
                                        _c("i", {
                                          staticClass: "mdi mdi-24px",
                                          class: [
                                            item.reportOnly ? "mdi-check" : "",
                                          ],
                                        }),
                                      ]
                                    ),
                              ]
                            ),
                            _vm.innerValue.quotingMethod ===
                            _vm.quotingMethodTypes.Hour
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-vertical-middle has-text-right money-input",
                                    class: [
                                      {
                                        tooltip:
                                          _vm.isItemInvoiced(item) === true,
                                      },
                                    ],
                                    attrs: {
                                      "data-tooltip":
                                        "Item rate is already invoiced!",
                                    },
                                  },
                                  [
                                    !_vm.innerValue.readOnly &&
                                    !_vm.readOnlyView &&
                                    !_vm.audanetLock &&
                                    !_vm.isItemRemoved(
                                      item,
                                      _vm.getItemAssessments(item)
                                    ) &&
                                    !_vm.isItemInvoiced(item)
                                      ? _c("vue-numeric", {
                                          staticClass: "input has-text-right",
                                          class: [
                                            _vm.defaultRowColourClass(
                                              item,
                                              _vm.getItemAssessments(item),
                                              false
                                            ),
                                            item.rate !==
                                            _vm.findLabourRate(
                                              item.itemType,
                                              _vm.innerValue.rates,
                                              _vm.innerValue.shopRate
                                            ).rate
                                              ? "is-warning"
                                              : "",
                                          ],
                                          attrs: { precision: 2 },
                                          on: {
                                            "value-changed": function ($event) {
                                              return _vm.updateValue(
                                                index,
                                                item
                                              )
                                            },
                                          },
                                          model: {
                                            value: item.rate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "rate",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "item.rate",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.formatNumber(
                                                item.rate,
                                                _vm.$userInfo.locale
                                              )
                                            )
                                          ),
                                        ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-right money-input",
                              },
                              [
                                !_vm.innerValue.readOnly &&
                                !_vm.readOnlyView &&
                                !_vm.audanetLock &&
                                !_vm.isItemRemoved(
                                  item,
                                  _vm.getItemAssessments(item)
                                )
                                  ? _c("vue-numeric", {
                                      staticClass: "input has-text-right",
                                      class: _vm.defaultRowColourClass(
                                        item,
                                        _vm.getItemAssessments(item),
                                        false
                                      ),
                                      attrs: {
                                        minus: _vm.innerValue.subQuoteNo !== 0,
                                        precision: 2,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.updateValue(index, item)
                                        },
                                      },
                                      model: {
                                        value: item.hourValue,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "hourValue",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.hourValue",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatNumber(
                                            item.hourValue,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-right",
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        item.dollarValue,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c("td", { staticClass: "has-vertical-middle" }, [
                              _vm._v(_vm._s(item.itemType)),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-centered",
                              },
                              [
                                item.presentAs
                                  ? _c(
                                      "div",
                                      _vm._l(item.presentAs, function (split) {
                                        return _c(
                                          "div",
                                          { key: split.itemType },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tags has-addons mb-0 present-as-tags",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: `tag mb-1 is-${split.itemType.toLowerCase()}`,
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(split.itemType)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tag is-dark mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(split.percent) +
                                                        "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$userInfo.isSupportUser,
                                    expression: "$userInfo.isSupportUser",
                                  },
                                ],
                                staticClass:
                                  "has-vertical-middle itemstatus-input",
                              },
                              [
                                !_vm.innerValue.readOnly &&
                                !_vm.readOnlyView &&
                                !_vm.isItemRemoved(
                                  item,
                                  _vm.getItemAssessments(item)
                                )
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.itemStatus,
                                          expression: "item.itemStatus",
                                        },
                                      ],
                                      staticClass: "input is-capitalized",
                                      domProps: { value: item.itemStatus },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "itemStatus",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(_vm._s(item.itemStatus)),
                                    ]),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-centered is-content-width",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "icon-container items-center",
                                  },
                                  [
                                    _vm.innerValue.quoteAssessments.length > 0
                                      ? _c("supplementary-icon", {
                                          staticClass: "icon",
                                          attrs: {
                                            item: item,
                                            "item-assessments":
                                              _vm.getItemAssessments(item),
                                            "next-assessment-number":
                                              _vm.nextSupplemetryNo,
                                            "quoting-method":
                                              _vm.innerValue.quotingMethod,
                                            "icon-size": 4,
                                          },
                                        })
                                      : _vm._e(),
                                    !_vm.audanetLock &&
                                    !_vm.isItemRemoved(
                                      item,
                                      _vm.getItemAssessments(item)
                                    ) &&
                                    (item.isDeleted === false ||
                                      item.deleted === false)
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button is-danger is-small is-inverted tooltip",
                                            attrs: {
                                              disabled:
                                                _vm.innerValue.readOnly ||
                                                _vm.readOnlyView ||
                                                _vm.isItemRemoved(
                                                  item,
                                                  _vm.getItemAssessments(item)
                                                ),
                                              "data-tooltip": "Delete",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteItem(
                                                  item,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-small" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-delete mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button has-background-primary-45 is-small is-inverted tooltip",
                                        attrs: {
                                          disabled: _vm.isItemRemoved(
                                            item,
                                            _vm.getItemAssessments(item)
                                          ),
                                          "data-tooltip": "Present As",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showPresentAsModal(
                                              item,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon is-small" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-format-page-split mdi-24px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-primary is-small is-inverted item-drag-handle pr-0 pl-1",
                                        attrs: {
                                          disabled:
                                            _vm.innerValue.readOnly ||
                                            _vm.readOnlyView,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon is-small" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-drag-vertical mdi-24px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                    _c("template", { slot: "footer" }, [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            attrs: { colspan: _vm.totalColSpan },
                          },
                          [_vm._v("Mech")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            class: { "has-text-danger": _vm.mechTotal < 0 },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.mechTotal,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c("th", { attrs: { colspan: "100%" } }),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            attrs: { colspan: _vm.totalColSpan },
                          },
                          [_vm._v("CD")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            class: { "has-text-danger": _vm.cdTotal < 0 },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.cdTotal,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c("th", { attrs: { colspan: "100%" } }),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            attrs: { colspan: _vm.totalColSpan },
                          },
                          [_vm._v("Crush")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            class: { "has-text-danger": _vm.crushTotal < 0 },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.crushTotal,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c("th", { attrs: { colspan: "100%" } }),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            attrs: { colspan: _vm.totalColSpan },
                          },
                          [_vm._v("FG")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right",
                            class: { "has-text-danger": _vm.fgTotal < 0 },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.fgTotal,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c("th", { attrs: { colspan: "100%" } }),
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right has-text-success",
                            attrs: { colspan: _vm.totalColSpan },
                          },
                          [_vm._v("Totals")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "has-text-right has-text-success",
                            class: [
                              _vm.otherTotal >= 0
                                ? "has-text-success"
                                : "has-text-danger",
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.otherTotal,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c("th", { attrs: { colspan: "100%" } }),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c("totals-floating-widget", {
                  attrs: {
                    active: _vm.isFloatingWidgetActive,
                    title: "Other Labour Totals",
                    "mech-total": _vm.mechTotal,
                    "cd-total": _vm.cdTotal,
                    "crush-total": _vm.crushTotal,
                    "fg-total": _vm.fgTotal,
                    totals: _vm.otherTotal,
                    "total-ex-gst": _vm.innerValue.totalExGst,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isFloatingWidgetActive = $event
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm.isPresentAsModalActive
        ? _c(
            "quote-item-present-as-modal",
            {
              attrs: { active: _vm.isPresentAsModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isPresentAsModalActive = $event
                },
                ok: function ($event) {
                  return _vm.closeModal()
                },
                cancel: function ($event) {
                  return _vm.closeModal()
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
              },
              model: {
                value: _vm.selectedItem.presentAs,
                callback: function ($$v) {
                  _vm.$set(_vm.selectedItem, "presentAs", $$v)
                },
                expression: "selectedItem.presentAs",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Present As"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }